(function () {
  window.MKCustom = window.MKCustom || {};

  if (window.MKCustom.KiteIntegration?.loaded) return;

  const KiteIntegration = {
    loaded: true,
    debug: false,
    originalFetch: null,
    originalGetButtonState: null,
    lastCartSnapshot: null,
    promoToastTimer: null,
    variantAvailabilityCache: new Map(),

    log(...args) {
      if (!this.debug) return;

      console.log(
        '[MK Kite Integration]',
        ...args
      );
    },

    getRequestUrl(input) {
      if (typeof input === 'string') {
        return input;
      }

      if (input && input.url) {
        return input.url;
      }

      return '';
    },

    isKiteRequest(input) {
      const url = this.getRequestUrl(input);

      if (!url) return false;

      return (
        url.includes('app=gfgfreegift') ||
        url.includes('kite') ||
        url.includes('gfg')
      );
    },

    isCartAddRequest(input) {
      const url = this.getRequestUrl(input);

      if (!url) return false;

      return (
        url.includes('/cart/add') ||
        url.includes('/cart/add.js')
      );
    },

    refreshCartDrawer() {
      document.dispatchEvent(
        new CustomEvent(
          'dispatch:cart-drawer:refresh'
        )
      );

      this.log(
        'Cart drawer refresh dispatched'
      );
    },

    openCartDrawer() {
      document.dispatchEvent(
        new CustomEvent(
          'dispatch:cart-drawer:open'
        )
      );

      this.log(
        'Cart drawer open dispatched'
      );
    },

    refreshAndOpenCartDrawer() {
      this.refreshCartDrawer();
      this.openCartDrawer();
    },

    handleSuccessfulKiteAdd(
      input,
      response
    ) {
      if (!response.ok) return;

      if (
        !this.isKiteRequest(input) ||
        !this.isCartAddRequest(input)
      ) {
        return;
      }

      this.log(
        'Successful Kite cart add detected',
        this.getRequestUrl(input)
      );

      /*
       * Keep the proven stable cart-drawer behavior.
       */
      window.setTimeout(() => {
        this.refreshAndOpenCartDrawer();
      }, 150);
    },

    getBxgyProductHandle(card) {
      const productLink = card.querySelector(
        '.gfgBXGY-product-link'
      );

      if (!productLink) return '';

      const attributeHandle =
        productLink.getAttribute('data-samitaws-handle') ||
        productLink.getAttribute('p-handle');

      if (attributeHandle) {
        return attributeHandle;
      }

      const href =
        productLink.getAttribute('href') || '';

      const match =
        href.match(/\/products\/([^/?#]+)/);

      return match ? match[1] : '';
    },

    async cacheBxgyProductAvailability(card) {
      const handle =
        this.getBxgyProductHandle(card);

      if (!handle) return;

      try {
        const response = await fetch(
          `/products/${encodeURIComponent(handle)}.js`,
          {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        if (!response.ok) {
          throw new Error(
            `Unable to read product ${handle}`
          );
        }

        const product =
          await response.json();

        if (!Array.isArray(product.variants)) {
          return;
        }

        product.variants.forEach(variant => {
          this.variantAvailabilityCache.set(
            String(variant.id),
            Boolean(variant.available)
          );
        });

        this.log(
          'Shopify promo availability cached',
          handle
        );

        return {
          handle,
          variants: product.variants,
          available: product.variants.some(
            variant => Boolean(variant.available)
          )
        };

      } catch (error) {
        console.warn(
          '[MK Kite Integration] Unable to validate promo availability:',
          handle,
          error
        );
       return null;
      }
    },

    patchBxgyButtonState(attempt = 0) {
      const api =
        window.gfgCustomDiscount
          ?.gfgBXGY
          ?.f;

      /*
       * Kite may load after the theme script.
       * Retry briefly until its BOGO API is available.
       */
      if (
        !api ||
        typeof api.getButtonState !== 'function'
      ) {
        if (attempt >= 40) {
          this.log(
            'Kite BOGO API unavailable; button-state patch skipped'
          );

          return;
        }

        window.setTimeout(() => {
          this.patchBxgyButtonState(
            attempt + 1
          );
        }, 250);

        return;
      }

      /*
       * Prevent this integration from patching
       * the same function more than once.
       */
      if (
        api.getButtonState
          .__mkcustomPatched
      ) {
        return;
      }

      this.originalGetButtonState =
        api.getButtonState;

      const integration = this;

      const patchedGetButtonState =
        function (
          variantId,
          promoTitle,
          outOfStock,
          locked
        ) {
          /*
           * Preserve Kite's native
           * out-of-stock priority.
           */
          if (outOfStock) {
            return 'out_of_stock';
          }

          /*
          * Shopify availability is authoritative.
          *
          * Kite can occasionally report a promo variant
          * as available even when Shopify has it sold out.
          */
          const shopifyAvailability =
            integration.variantAvailabilityCache.get(
              String(variantId)
            );

          if (shopifyAvailability === false) {
            return 'out_of_stock';
          }

          /*
           * Kite already stores added promo variants
           * in addedVariantsInCart.
           *
           * Its native function incorrectly ignores
           * this state whenever "locked" is false,
           * which causes:
           *
           * Remove item
           * → Add item
           *
           * during its post-cart render.
           */
          const addedItem =
            window.gfgCustomDiscount
              ?.gfgBXGY
              ?.state
              ?.addedVariantsInCart
              ?.[promoTitle]
              ?.[String(variantId)];

          /*
           * If Kite itself knows this variant is
           * already in the cart, preserve its native
           * "added" / Remove item state.
           */
          if (addedItem) {
            return 'added';
          }

          /*
           * Preserve Kite's native locked state.
           */
          if (locked) {
            return 'locked';
          }

          /*
           * Normal available promo item.
           */
          return 'add_to_cart';
        };

      patchedGetButtonState
        .__mkcustomPatched = true;

      api.getButtonState =
        patchedGetButtonState;

      integration.log(
        'Kite BOGO button-state patch initialized'
      );
    },
    
    formatBxgySavings(discountType, discountValue) {
      const numericValue =
        Number(discountValue);

      if (!Number.isFinite(numericValue)) {
        return '';
      }

      const normalizedType =
        String(discountType || '')
          .toUpperCase();

      /*
      * Percentage promotions
      */
      if (
        normalizedType.includes('PERCENT')
      ) {
        return `${numericValue}%`;
      }

      /*
      * Fixed-dollar promotions
      */
      return new Intl.NumberFormat(
        'en-US',
        {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits:
            Number.isInteger(numericValue) ? 0 : 2,
          maximumFractionDigits: 2
        }
      ).format(numericValue);
    },

        renderBxgyStatusMessage(
      actionTitle,
      message,
      savings
    ) {
      if (
        !actionTitle ||
        !message
      ) {
        return;
      }

      /*
       * Determine which part of the message
       * deserves stronger visual emphasis.
       */
      const highlightCandidates = [
        `Save an additional ${savings}`,
        `${savings} savings applied`,
        `unlock ${savings}`,
        `save ${savings} on each`,
        `save ${savings}`
      ];

      const highlightText =
        highlightCandidates.find(candidate =>
          message.includes(candidate)
        );

      /*
       * No special phrase found:
       * render the message normally.
       */
      if (!highlightText) {
        actionTitle.textContent =
          message;

        return;
      }

      const highlightIndex =
        message.indexOf(highlightText);

      const beforeText =
        message.slice(
          0,
          highlightIndex
        );

      const afterText =
        message.slice(
          highlightIndex +
          highlightText.length
        );

      /*
       * Rebuild the title safely so only
       * the important phrase is emphasized.
       */
      actionTitle.textContent = '';

      if (beforeText) {
        actionTitle.appendChild(
          document.createTextNode(
            beforeText
          )
        );
      }

      const highlight =
        document.createElement('strong');

      highlight.className =
        'mkcustom-bxgy-status__highlight';

      highlight.textContent =
        highlightText;

      actionTitle.appendChild(
        highlight
      );

      if (afterText) {
        actionTitle.appendChild(
          document.createTextNode(
            afterText
          )
        );
      }
    },

    getBxgyDynamicStatusMessage(
      container,
      settings
    ) {
      const promoTitle =
        settings?.discountTitle;

      if (!promoTitle) return null;

      const state =
        window.gfgCustomDiscount
          ?.gfgBXGY
          ?.state;

      if (!state) return null;

      const promoProducts =
        state.productsDataForBuyXGetY
          ?.[promoTitle] || [];

      /*
      * Only use the special dynamic wording
      * when there are multiple promo choices.
      */
    if (promoProducts.length <= 1) {
      const savings =
        this.formatBxgySavings(
          settings.discountType,
          settings.discountValue
        );

      if (!savings) return null;

      const fulfilled =
        Boolean(
          state.BuyXConditionFulfilled
            ?.[promoTitle]
        );

      const hasAddedPromoItem =
        Boolean(
          container.querySelector(
            '.gfgBuyXGetYProductAddToCartBtn.gfgBXGY-btn-remove'
          )
        );

      const hasAvailablePromoItem =
        Boolean(
          container.querySelector(
            '.gfgBuyXGetYProductAddToCartBtn:not(.gfgBXGY-btn-locked):not(.gfgBXGY-btn-remove):not(.disabled)'
          )
        );

      /*
      * Single-product Added state
      * stays handled by renderBxgyOfferHeaders().
      */
      if (hasAddedPromoItem) {
        return null;
      }

      /*
      * Keep Kite's normal locked wording.
      *
      * Treat either Kite's fulfillment state OR
      * an actually available Add button as proof
      * that the promo is unlocked.
      */
      if (
        !fulfilled &&
        !hasAvailablePromoItem
      ) {
        return `Add this item to unlock ${savings} off this product`;
      }

      /*
      * Single-product unlocked state.
      */
      return `Save an additional ${savings} on this product`;
    }

      const allowedQuantity =
        Number(
          state.allowedGetYQuantity
            ?.[promoTitle] || 0
        );

      const fulfilled =
        Boolean(
          state.BuyXConditionFulfilled
            ?.[promoTitle]
        );

      const savings =
        this.formatBxgySavings(
          settings.discountType,
          settings.discountValue
        );

      if (!savings) return null;

      const addedVariants =
        state.addedVariantsInCart
          ?.[promoTitle] || {};

      const addedQuantity =
        Object.keys(
          addedVariants
        ).length;

      const remainingQuantity =
        Math.max(
          allowedQuantity - addedQuantity,
          0
        );

      /*
      * Multi-product partial / complete claim states
      */
      if (addedQuantity > 0) {
        /*
        * Customer can still claim more promo products.
        */
        if (remainingQuantity > 0) {
          const productLabel =
            remainingQuantity === 1
              ? 'product'
              : 'products';

          return `${savings} savings applied — choose ${remainingQuantity} more ${productLabel}`;
        }

        /*
        * All currently available promo claims
        * have been used.
        */
        const productLabel =
          addedQuantity === 1
            ? 'product'
            : 'products';

        return `${savings} savings applied to ${addedQuantity} ${productLabel}`;
      }

      /*
      * Locked / not yet qualified
      */
      if (!fulfilled) {
        return `Add this item to unlock ${savings} off one of these products`;
      }

      /*
      * Qualified for one promo item
      */
      if (allowedQuantity <= 1) {
        return `Choose 1 product below and save ${savings}`;
      }

      /*
      * Qualified for multiple promo items
      */
      return `Choose up to ${allowedQuantity} products below and save ${savings} on each`;
    },
    
    async validateBxgyProductAvailability() {
      const containers =
        document.querySelectorAll(
          '.gfgBuyXGetYCustomDiscountParentContainer'
        );

      for (const container of containers) {
        const cards =
          container.querySelectorAll(
            '.gfgBuyXGetYSingleProductCard'
          );

        if (!cards.length) continue;

        let availableCardCount = 0;

        for (const card of cards) {
          const result =
            await this.cacheBxgyProductAvailability(
              card
            );

          const button =
            card.querySelector(
              '.gfgBuyXGetYProductAddToCartBtn'
            );

          /*
          * If Shopify could not be checked,
          * leave Kite's current state alone.
          */
          if (!result) {
            availableCardCount += 1;
            continue;
          }

          /*
          * Shopify says at least one variant
          * on this promo product is available.
          */
          if (result.available) {
            availableCardCount += 1;

            card.removeAttribute(
              'data-mkcustom-kite-out-of-stock'
            );

            if (
              button &&
              button.getAttribute(
                'data-mkcustom-kite-out-of-stock'
              ) === 'true'
            ) {
              button.disabled = false;

              button.classList.remove(
                'disabled'
              );

              button.removeAttribute(
                'aria-disabled'
              );

              button.removeAttribute(
                'data-mkcustom-kite-out-of-stock'
              );
            }

            continue;
          }

          /*
          * Shopify is authoritative:
          * this promotional product cannot be purchased.
          */
          card.setAttribute(
            'data-mkcustom-kite-out-of-stock',
            'true'
          );

          if (button) {
            button.disabled = true;

            button.classList.add(
              'disabled'
            );

            button.setAttribute(
              'aria-disabled',
              'true'
            );

            button.setAttribute(
              'data-mkcustom-kite-out-of-stock',
              'true'
            );

            button.textContent =
              'Out of Stock';
          }
        }

        /*
        * Hide the entire Bonus Offer only when
        * every promo choice is unavailable.
        *
        * If even one choice is available,
        * keep the promotion visible.
        */
        if (availableCardCount === 0) {
          container.style.setProperty(
            'display',
            'none',
            'important'
          );

          container.setAttribute(
            'data-mkcustom-kite-all-out-of-stock',
            'true'
          );
        } else if (
          container.getAttribute(
            'data-mkcustom-kite-all-out-of-stock'
          ) === 'true'
        ) {
          container.style.removeProperty(
            'display'
          );

          container.removeAttribute(
            'data-mkcustom-kite-all-out-of-stock'
          );
        }
      }
    },

    renderBxgyOfferHeaders() {
      const containers =
        document.querySelectorAll(
          '.gfgBuyXGetYCustomDiscountParentContainer'
        );

      containers.forEach(container => {
        let settings = {};

        try {
          settings = JSON.parse(
            container.getAttribute(
              'data-discountsettings'
            ) || '{}'
          );
        } catch (error) {
          this.log(
            'Unable to parse BOGO discount settings',
            error
          );

          return;
        }

        const savings =
          this.formatBxgySavings(
            settings.discountType,
            settings.discountValue
          );

        if (!savings) return;

        let header =
          container.querySelector(
            ':scope > .mkcustom-bxgy-offer-header'
          );

        /*
        * Create our presentation-only header once.
        */
        if (!header) {
          header =
            document.createElement('div');

          header.className =
            'mkcustom-bxgy-offer-header';

        const label =
          document.createElement('div');

        label.className =
          'mkcustom-bxgy-offer-header__label';

        /*
        * Gift icon
        */
        const giftIcon =
          document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg'
          );

        giftIcon.setAttribute(
          'class',
          'mkcustom-bxgy-offer-header__icon'
        );

        giftIcon.setAttribute(
          'viewBox',
          '0 0 24 24'
        );

        giftIcon.setAttribute(
          'aria-hidden',
          'true'
        );

        giftIcon.innerHTML = `
          <path
            d="M20 12v10H4V12M2 7h20v5H2V7Zm10 15V7M12 7H7.5A2.5 2.5 0 0 1 5 4.5 2.5 2.5 0 0 1 7.5 2C10 2 12 7 12 7Zm0 0h4.5A2.5 2.5 0 0 0 19 4.5 2.5 2.5 0 0 0 16.5 2C14 2 12 7 12 7Z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        `;

        const labelText =
          document.createElement('span');

        labelText.textContent =
          'BONUS OFFER';

        label.appendChild(giftIcon);
        label.appendChild(labelText);

        header.appendChild(label);

          /*
          * Put the offer header above everything
          * Kite renders inside the BOGO module.
          */
          container.insertBefore(
            header,
            container.firstChild
          );
        }

        /*
         * Generate special messaging only when
         * this BOGO contains multiple promo choices.
         */
        const dynamicStatusMessage =
          this.getBxgyDynamicStatusMessage(
            container,
            settings
          );

        const actionTitle =
          container.querySelector(
            '.gfgBuyXGetYAccordionTitle'
          );

        if (
          actionTitle &&
          dynamicStatusMessage
        ) {
          this.renderBxgyStatusMessage(
            actionTitle,
            dynamicStatusMessage,
            savings
          );
        }


        /*
         * Determine whether this is a normal
         * single-product BOGO or a multi-choice BOGO.
         */
        const promoTitle =
          settings.discountTitle;

        const promoProducts =
          window.gfgCustomDiscount
            ?.gfgBXGY
            ?.state
            ?.productsDataForBuyXGetY
            ?.[promoTitle] || [];

        const hasAddedPromoItem =
          Boolean(
            container.querySelector(
              '.gfgBuyXGetYProductAddToCartBtn.gfgBXGY-btn-remove'
            )
          );


        /*
         * Keep our existing simple Added wording
         * only for normal single-product BOGO offers.
         *
         * Multi-product offers use the dynamic
         * message generated above instead.
         */
        if (
          actionTitle &&
          hasAddedPromoItem &&
          promoProducts.length <= 1
        ) {
          actionTitle.textContent =
            'Offer added to your cart';
        }
      });
    },

    initBxgyOfferHeaders(attempt = 0) {
      const containers =
        document.querySelectorAll(
          '.gfgBuyXGetYCustomDiscountParentContainer'
        );

      if (!containers.length) {
        if (attempt >= 40) {
          this.log(
            'Kite BOGO containers unavailable; offer headers skipped'
          );

          return;
        }

        window.setTimeout(() => {
          this.initBxgyOfferHeaders(
            attempt + 1
          );
        }, 250);

        return;
      }

      this.renderBxgyOfferHeaders();
      this.validateBxgyProductAvailability();

      /*
      * Kite replaces the entire BOGO parent container
      * after qualification/cart state changes.
      *
      * Watch only for newly-added BOGO parent containers,
      * then restore our presentation header.
      */
      if (!this.bxgyParentObserver) {
        const integration = this;

        this.bxgyParentObserver =
          new MutationObserver(records => {
            let foundNewBxgyContainer = false;

            records.forEach(record => {
              record.addedNodes.forEach(node => {
                if (
                  node.nodeType !==
                  Node.ELEMENT_NODE
                ) {
                  return;
                }

                if (
                  node.matches?.(
                    '.gfgBuyXGetYCustomDiscountParentContainer'
                  ) ||
                  node.querySelector?.(
                    '.gfgBuyXGetYCustomDiscountParentContainer'
                  )
                ) {
                  foundNewBxgyContainer = true;
                }
              });
            });

            if (!foundNewBxgyContainer) return;

            /*
            * Give Kite one frame to finish attaching
            * the replacement container.
            */
            window.requestAnimationFrame(() => {
              integration.renderBxgyOfferHeaders();
              integration.validateBxgyProductAvailability();
            });
          });

        this.bxgyParentObserver.observe(
          document.body,
          {
            childList: true,
            subtree: true
          }
        );
      }

      this.log(
        'Kite BOGO replacement observer initialized'
      );
    },

    async getCurrentCart() {
      const fetchFunction =
        this.originalFetch || window.fetch;

      const response = await fetchFunction('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to read Shopify cart');
      }

      return response.json();
    },

    getKitePromoItems(cart) {
      if (!cart?.items) return [];

      return cart.items.filter(item => {
        return Boolean(
          item.properties?._kite_promo_name
        );
      });
    },

    showPromoToast(productTitle) {
      let toast = document.querySelector(
        '.mkcustom-kite-promo-toast'
      );

      if (!toast) {
        toast = document.createElement('div');

        toast.className =
          'mkcustom-kite-promo-toast';

        toast.setAttribute(
          'role',
          'status'
        );

        toast.setAttribute(
          'aria-live',
          'polite'
        );

        document.body.appendChild(toast);
      }

      toast.innerHTML = `
        <strong class="mkcustom-kite-promo-toast__label">
          Promo item removed:
        </strong>
        <span class="mkcustom-kite-promo-toast__product">
          ${productTitle}
        </span>
      `;

      toast.classList.add(
        'mkcustom-kite-promo-toast--visible'
      );

      window.clearTimeout(
        this.promoToastTimer
      );

      this.promoToastTimer =
        window.setTimeout(() => {
          toast.classList.remove(
            'mkcustom-kite-promo-toast--visible'
          );
        }, 3000);
    },

    async detectRemovedPromoItem() {
      try {
        const newCart =
          await this.getCurrentCart();

        if (!this.lastCartSnapshot) {
          this.lastCartSnapshot = newCart;
          return;
        }

        const previousPromoItems =
          this.getKitePromoItems(
            this.lastCartSnapshot
          );

        const currentPromoKeys = new Set(
          this.getKitePromoItems(newCart)
            .map(item => item.key)
        );

        const removedPromoItems =
          previousPromoItems.filter(item => {
            return !currentPromoKeys.has(
              item.key
            );
          });

        removedPromoItems.forEach(item => {
          this.showPromoToast(
            item.product_title ||
            item.title ||
            'Promotional item'
          );
        });

        this.lastCartSnapshot = newCart;
      } catch (error) {
        console.warn(
          '[MK Kite Integration] Promo removal detection failed:',
          error
        );
      }
    },

    isCartMutationRequest(input) {
      const url = this.getRequestUrl(input);

      if (!url) return false;

      return (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      );
    },


    initFetchBridge() {
      if (this.originalFetch) return;

      this.originalFetch = window.fetch;

      const integration = this;

      window.fetch = async function (...args) {
        const response =
          await integration.originalFetch.apply(
            this,
            args
          );

      try {
        integration.handleSuccessfulKiteAdd(
          args[0],
          response
        );

        if (
          response.ok &&
          integration.isCartMutationRequest(
            args[0]
          )
        ) {
          /*
          * Promo removal detection.
          */
          window.setTimeout(() => {
            integration.detectRemovedPromoItem();
          }, 150);
        }
      } catch (error) {
        console.warn(
          '[MK Kite Integration] Cart synchronization failed:',
          error
        );
      }

        return response;
      };

      this.log(
        'Fetch bridge initialized'
      );
    },

    init() {
      this.initFetchBridge();
      this.patchBxgyButtonState();
      this.initBxgyOfferHeaders();

      this.getCurrentCart()
        .then(cart => {
          this.lastCartSnapshot = cart;
        })
        .catch(error => {
          console.warn(
            '[MK Kite Integration] Initial cart snapshot failed:',
            error
          );
        });

      this.log(
        'Integration initialized'
      );
    }
  };

  window.MKCustom.KiteIntegration =
    KiteIntegration;

  KiteIntegration.init();
})();